<template>
    <v-btn icon @click="addRoutine">
        <v-icon color="secondary">mdi-plus</v-icon>
    </v-btn>
</template>

<script>

export default {
    components:{
        //
    },
    methods: {
        addRoutine() {
            const vm = this
            vm.$router.push({name: `${vm.accountType}.routines.create`})
        }
    },
}
</script>